import moveOptionToEnd from "./moveOptionToEnd";
import sortByKey from "./sortByKey";
const sortOptions = _ref => {
  let {
    moveToEndValue,
    moveToEndValueKey = 'value',
    options = [],
    sortKey = 'label',
    sortDirection = 'asc'
  } = _ref;
  return moveOptionToEnd({
    options: sortByKey({
      options,
      sortKey,
      sortDirection
    }),
    value: moveToEndValue,
    valueKey: moveToEndValueKey
  });
};
export default sortOptions;
//# sourceMappingURL=sortOptions.js.map